import { extractError, extractErrorFromSap } from '../service/response.service'
import { extendObservable, autorun } from 'mobx'
import { api } from '../service/api.service'
import {
  buildValidators,
  required
} from '../service/validate'
import t from '../service/translate.service'
import { Buffer } from 'buffer'
import DOMPurify from 'dompurify';

class RepairsAndIquiriesStore {
  constructor() {
    extendObservable(this, {
      reports: [],
      statuses: [],
      page: 0,
      pageSize: 10,
      activeStatus: '0',
      selectedReport: {},
      files: [],
      showLoadMore: true,
      submitted: false,
      loading: true,
      showSuccessMessage: false,
      showAmendForm: false,
      error: '',
      amendment: '',
      excludedFiles: []
    })
  }
  addFile = (files) => {
    if (files.length) {
      files.forEach(file => this.files.push(file))
      this.error = ''
    } else {
      this.error = t.INVALID_FILE_TYPE
    }
  }
  get validators() {
    return buildValidators(
      {
        message: [required]
      },
      this.submitted
    )
  }
  async getReports(page = 0, pageSize = 999, status = '0') {
    try {
      this.loading = true
      const res = await api.get(`/damage-report?page=${page}&pageSize=${pageSize}&status=${status}`)
      const reports = res.data.filter(r => r.contract !== null)
      if (this.page == 0 && page == 0) {
        this.reports = reports.sort((a, b) => new Date(b.create_date) - new Date(a.create_date)).slice(0, pageSize)
        if (reports?.length < 10) {
          this.showLoadMore = false
        } else {
          this.showLoadMore = true
        }
        this.selectedReport = reports[0]
      } else {
        const newReports = [...this.reports, ...reports].sort((a, b) => new Date(b.create_date) - new Date(a.create_date)).slice(0, (page + 1) * pageSize)
        if (this.reports?.length === newReports?.length || newReports?.length < (page + 1) * pageSize) {
          this.showLoadMore = false
        } else {
          this.showLoadMore = true
        }
        this.reports = newReports
      }
      const statuses = await api.get(`/repair-and-inquiry-statuses`)
      this.statuses = statuses.data
      this.loading = false
      return
    } catch (err) {
      if (this.page > 0) {
        this.page = this.page - 1
      }
      extractError(err)
    }
  }
  onAmendInput = (value) => {
    this.amendment = DOMPurify.sanitize(value)
  }
  
  changeStatus = (status = '0') => {
    this.page = 0
    this.activeStatus = status
    this.getReports(0, this.pageSize, status)
  }

  async submitAmendment(reportId, amendment) {
    this.submitted = true
    const isValid = !this.validators.message(amendment)
    if (!isValid) {
      this.loading = false
      return
    }
    const data = new FormData()

    data.append('repairAndInquiryId', reportId.toString())
    data.append('amendment', amendment)

    this.files.forEach((file, i) => data.append(`file_${i}`, file, file.name))

    try {
      const res = await api.post(`/repair-and-inquiry-amendment`, data, {
        timeout: 300000, headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      this.reports = this.reports.map(report => {
        if (report.code === reportId) {
          report.user_comment = report.user_comment.concat(res.data)
          this.selectedReport = report
        }
        return report
      })
      this.loading = false
      this.showSuccessMessage = true
      this.showAmendForm = false
      this.excludedFiles = res?.data?.excludedFiles || []
      this.loading = false
      this.files = []
      this.amendment = ''
    } catch (err) {
      this.loading = false
      this.error = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
    }
  }

  async getAttachments(srNumber) {
    try {
      const res = await api.get(`/v1/damage-report/files/${srNumber}`)
      return res.data
    } catch (err) {
      this.loading = false
      this.error = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
      throw err
    }
  }

  async getPropertyRooms(contractNumber) {
    try {
      const res = await api.get(`/contract/${contractNumber}/property-rooms`)
      return res.data
    } catch (err) {
      this.loading = false
      this.error = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
      throw err
    }
  }

  async createDamageReportV2(data) {
    try {
      const res = await api.post('v2/damage-report', data, {
        timeout: 300000,
        headers: {
          'Content-Type': `multipart/form-data;`
        }
      })
      return res.data
    } catch (err) {
      this.loading = false
      this.error = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
      throw err
    }
  }

  async imageAnalyze(data) {
    try {
      const res = await api.post('damage-report/image/analyze', data, {
        timeout: 300000,
        headers: {
          'Content-Type': `multipart/form-data;`
        }
      })
      return res.data
    } catch (err) {
      this.loading = false
      this.error = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
      throw err
    }
  }

  async updateDamageReport(serviceRequestId, data) {
    try {
      const res = await api.post(`damage-report/${serviceRequestId}`, data, {
        timeout: 300000,
        headers: {
          'Content-Type': `multipart/form-data;`
        }
      })
      return res.data
    } catch (err) {
      this.loading = false
      this.error = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
      throw err
    }
  }

  async getTicketById(srNumber) {
    try {
      const res = await api.get(`/damage-report/${srNumber}`)
      return res.data
    } catch (err) {
      this.loading = false
      this.error = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
    }
  }
}

export default RepairsAndIquiriesStore
